import React, { useId, useState } from 'react';
import { Alert, Button, TextArea } from '@kontentino/ui';
import { useTranslation } from 'react-i18next';
import { useSocialLoginContext } from 'app/modules/socialLogin/context';

interface ManualSystemUserTokenFormProps {
  pageType: number;
}

const ManualSystemUserTokenForm = ({
  pageType,
}: ManualSystemUserTokenFormProps) => {
  const { t } = useTranslation();
  const { submitSystemUserToken, isSubmittingToken, error } =
    useSocialLoginContext();
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [token, setToken] = useState('');
  const textAreaId = useId();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const trimmedToken = token.trim();

    if (trimmedToken) {
      setHasSubmitted(true);
      submitSystemUserToken(pageType, trimmedToken);
    }
  };

  const inlineError =
    hasSubmitted && !isSubmittingToken && typeof error?.reason === 'string'
      ? error.reason
      : null;

  return (
    <form
      className="tw-flex tw-w-full tw-flex-col tw-gap-4"
      onSubmit={handleSubmit}
      data-cy="safe-connect_manual-token-form"
    >
      <div className="tw-flex tw-flex-col tw-gap-2">
        <label htmlFor={textAreaId} className="tw-text-md tw-font-medium">
          {t('newSocialMediaProfile.systemUserToken.label')}
        </label>
        <TextArea
          id={textAreaId}
          value={token}
          onChange={(e) => setToken(e.target.value)}
          rows={4}
          placeholder={t('newSocialMediaProfile.systemUserToken.placeholder')}
          data-cy="safe-connect_manual-token-input"
        />
        <span className="tw-text-sm tw-text-grayscale-100">
          {t('newSocialMediaProfile.systemUserToken.help')}
        </span>
      </div>
      {inlineError && (
        <Alert variant="danger" data-cy="safe-connect_manual-token-error">
          {inlineError}
        </Alert>
      )}
      <Button
        type="submit"
        isLoading={isSubmittingToken}
        disabled={!token.trim()}
        data-cy="safe-connect_manual-token-submit"
      >
        {t('newSocialMediaProfile.systemUserToken.submit')}
      </Button>
    </form>
  );
};

export default ManualSystemUserTokenForm;
